import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateAboutFamily = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    aboutFamily: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      aboutFamily: data.aboutFamily,
    };

    api
      .post("/admin/userProfile/aboutFamilyUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "About Family updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update About Family", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        setData({
          aboutFamily: d.userFamily.aboutFamily || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load about family", "error");
      });
  }, [id]);

  return (
    <div className="content mt-5">
      <Row>
        <Col xs={12} md={12}>
          <div className="page-title mt-5">
            <div className="float-left">
              <h1 className="title">Update Expectations</h1>
            </div>
          </div>

          <div className="col-12">
            <section className="box">
              <div className="content-body">
                <Form onSubmit={handleSubmit}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormGroup>
                      <Label> About Family</Label>
                      <Input
                        type="textarea"
                        name="aboutFamily"
                        value={data.aboutFamily}
                        onChange={handleChange}
                        placeholder="Enter  about family"
                        rows={5}
                      />
                    </FormGroup>

                    <Button style={{ background: "black", color: "white" }}>
                      Submit
                    </Button>
                  </Box>
                </Form>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UpdateAboutFamily;
